const types = {
  // GET ALL OBLP LISTING
  GET_OBLP_LISTING: "GET_OBLP_LISTING",
  GET_OBLP_LISTING_RESP: "GET_OBLP_LISTING_RESP",
  GET_OBLP_LISTING_CLEAR: "GET_OBLP_LISTING_CLEAR",

  // GET ALL NON-OBLP LISTING
  GET_NON_OBLP_LISTING: "GET_NON_OBLP_LISTING",
  GET_NON_OBLP_LISTING_RESP: "GET_NON_OBLP_LISTING_RESP",
  GET_NON_OBLP_LISTING_CLEAR: "GET_NON_OBLP_LISTING_CLEAR",

  // GET MY OBLP LISTING
  GET_MY_OBLP_LISTING: "GET_MY_OBLP_LISTING",
  GET_MY_OBLP_LISTING_RESP: "GET_MY_OBLP_LISTING_RESP",
  GET_MY_OBLP_LISTING_CLEAR: "GET_MY_OBLP_LISTING_CLEAR",

  // GET MY NON-OBLP LISTING
  GET_NON_MY_OBLP_LISTING: "GET_NON_MY_OBLP_LISTING",
  GET_NON_MY_OBLP_LISTING_RESP: "GET_NON_MY_OBLP_LISTING_RESP",
  GET_NON_MY_OBLP_LISTING_CLEAR: "GET_NON_MY_OBLP_LISTING_CLEAR",

  //Global Search LP
  GLOBAL_SEARCH_LP: " GLOBAL_SEARCH_LP",
  GLOBAL_SEARCH_LP_RESPONSE: " GLOBAL_SEARCH_LP_RESPONSE",
  GLOBAL_SEARCH_LP_CLEAR: " GLOBAL_SEARCH_LP_CLEAR",

  //LP Included with subscription
  LP_INCLUDED_WITH_SUBSCRIPTION: "LP_INCLUDED_WITH_SUBSCRIPTION",
  LP_INCLUDED_WITH_SUBSCRIPTION_RESPONSE:
    "LP_INCLUDED_WITH_SUBSCRIPTION_RESPONSE",
  LP_INCLUDED_WITH_SUBSCRIPTION_CLEAR: "LP_INCLUDED_WITH_SUBSCRIPTION_CLEAR",

  GET_SURVEY: "GET_SURVEY",
  GET_SURVEY_RESP: "GET_SURVEY_RESP",
  GET_SURVEY_CLEAR: "GET_SURVEY_CLEAR",
  
  SHOW_SURVEY: "SHOW_SURVEY",
  SHOW_SURVEY_RESP: "SHOW_SURVEY_RESP",
  SHOW_SURVEY_CLEAR: "SHOW_SURVEY_CLEAR",

  SUBMIT_SURVEY: "SUBMIT_SURVEY",
  SUBMIT_SURVEY_RESP: "SUBMIT_SURVEY_RESP",
  SUBMIT_SURVEY_CLEAR: "SUBMIT_SURVEY_CLEAR",
    
  SHOW_TEMPLATE: "SHOW_TEMPLATE",
  SHOW_TEMPLATE_RESP: "SHOW_TEMPLATE_RESP",
  SHOW_TEMPLATE_CLEAR: "SHOW_TEMPLATE_CLEAR",

};

export default types;
